import { __assign, __extends } from "tslib";
import * as React from 'react';
import AutosizeInput from 'react-input-autosize';
import { infoMark, errorMark, lockMark } from './icons';
import { checkIfMobile } from '../utils';
import { Icon, Popover } from '@wix/answers-ui-libby';
import { RenderHtml } from '../../utils';
import { classNames, noop } from '@wix/answers-lib';
var DEBOUNCE_TIMEOUT = 200;
var MarketingInput = /** @class */ (function (_super) {
    __extends(MarketingInput, _super);
    function MarketingInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tooltipDebounce = null;
        _this.inputRef = null;
        _this.state = {
            isFocused: false,
            showTooltip: false,
            isMobile: checkIfMobile()
        };
        _this.onResize = function () {
            if (!_this.state.isMobile && checkIfMobile()) {
                _this.setState({ isMobile: true });
            }
            else if (_this.state.isMobile && !checkIfMobile()) {
                _this.setState({ isMobile: false });
            }
        };
        _this.focusInput = function () {
            if (!!_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        _this.onFocus = function () {
            if (_this.props.onFocus) {
                _this.props.onFocus();
            }
            _this.setState({ isFocused: true });
        };
        _this.onBlur = function () {
            if (_this.props.onBlur && _this.props.value) {
                _this.props.onBlur();
            }
            _this.setState({ isFocused: false });
        };
        _this.showTooltip = function () {
            if (_this.tooltipDebounce) {
                clearTimeout(_this.tooltipDebounce);
            }
            _this.setState({ showTooltip: true });
        };
        _this.hideTooltip = function () {
            _this.tooltipDebounce = setTimeout(function () { return _this.setState({ showTooltip: false }); }, DEBOUNCE_TIMEOUT);
        };
        _this.maybeRenderInfoTooltip = function () {
            var _a = _this, props = _a.props, state = _a.state;
            var tooltipText = props.infoText || props.disabledText || '';
            var tooltipBody = tooltipText ? (React.createElement("span", { className: 'tooltip-body', onMouseOver: _this.showTooltip, onMouseOut: _this.hideTooltip },
                React.createElement(RenderHtml, { html: tooltipText }))) : '';
            return tooltipText ? (React.createElement("span", { className: 'tooltip-wrapper', onMouseOver: _this.showTooltip, onMouseOut: _this.hideTooltip },
                React.createElement(Popover, { className: 'info-tooltip', isOpen: state.showTooltip, preferPlace: 'right', body: tooltipBody, onOuterAction: _this.hideTooltip },
                    React.createElement(Icon, { icon: infoMark })))) : null;
        };
        return _this;
    }
    MarketingInput.prototype.componentDidMount = function () {
        if (this.props.startFocused) {
            setTimeout(this.focusInput, 300);
        }
        window.addEventListener('resize', this.onResize);
    };
    MarketingInput.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
    };
    MarketingInput.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var _a = this.state, isFocused = _a.isFocused, isMobile = _a.isMobile;
        var showLabel = isFocused || !!props.value;
        var inputClasses = classNames('marketing-input', props.className, { 'show-label': showLabel, 'has-error': !!props.error, focused: isFocused, 'is-mobile': isMobile });
        var inputMarker = props.error ? React.createElement(Icon, { className: 'error-icon', icon: errorMark }) : this.maybeRenderInfoTooltip();
        var inputLockMarker = props.disabledText ? React.createElement(Icon, { className: 'lock-icon', icon: lockMark }) : null;
        var inputProps = {
            ref: function (ref) { return _this.inputRef = ref; },
            type: props.type,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            value: props.value,
            onChange: function (e) { return props.onChange(e.target.value); },
            disabled: !!props.disabledText
        };
        var inputComp = props.maxLength ?
            React.createElement(AutosizeInput, __assign({ maxLength: props.maxLength }, inputProps)) : React.createElement("input", __assign({}, inputProps));
        var errorBody = props.error ? React.createElement("span", { className: 'error-body' },
            React.createElement(RenderHtml, { html: props.error || '' })) : '';
        var InputWithError = !isMobile ? (React.createElement(Popover, { className: 'error-tooltip', body: errorBody, isOpen: !!props.error && !isFocused, preferPlace: props.errorTooltipPosition || 'left', onOuterAction: noop }, inputComp)) : (React.createElement("span", null,
            inputComp,
            errorBody));
        var fixedPlaceholder = this.props.fixedPlaceholder ?
            React.createElement("span", { className: 'fixed-placeholder', onClick: this.focusInput }, this.props.fixedPlaceholder) : null;
        return (React.createElement("div", { className: inputClasses, onClick: this.focusInput },
            React.createElement("label", { onClick: this.focusInput }, props.label),
            inputLockMarker,
            InputWithError,
            fixedPlaceholder,
            inputMarker,
            React.createElement("span", { className: 'focus-line' })));
    };
    return MarketingInput;
}(React.PureComponent));
export { MarketingInput };
//# sourceMappingURL=marketing-input.js.map